import React from 'react';
import { Link } from 'react-router-dom';
import { Button, FromGroup, Input, Col, Row, Container } from 'reactstrap';
import _ from 'lodash'
import api from '../../api';
import './index.css';
import UserObject from '../../components/UserObject';

export default class UserManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchKeyword: '',
            users: [],
            searchResultCount: 0,
            isSearching: false,
            currentUser: {
                is_system_admin: 0,
            },
            newUser: {
                email: '',
                first_name: '',
                middle_name: '',
                last_name: '',
                is_system_admin: 0
            },
            isCreatingNewUser: false,
        }
    }
    componentWillMount() {
        this.getCurrentUser();
        this.getAllUsers();
    }
    componentDidMount = () => {
        document.title = "DataDex";
    }
    toogleCreateNewUser() {
        const { isCreatingNewUser } = this.state;
        this.setState({ isCreatingNewUser: !isCreatingNewUser });
    }
    setSearchKeyword(value) {
        this.setState({ searchKeyword: value, isSearching: true }, this.search);
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: 'user/me',
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({ currentUser: response.user })
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    getAllUsers() {
        api.fetchAPI({
            method: 'get',
            uri: 'users',
            success: (response) => {
                this.setState({
                    users: response.users,
                });
            },
            error: (error) => {
              console.error(error);
            }
        });
        this.setState({ isSearching: false });
    }
    render() {
        const { searchKeyword, searchResultCount, users, isSearching, currentUser, isCreatingNewUser, newUser } = this.state;
        const isCurrentUserAdmin = currentUser.is_system_admin;

        if (isCurrentUserAdmin <= 0) return null;
        return (
            <div style={{ marginTop: 50 }}>
                {currentUser &&
                    <Row>
                        <Col xs={12}>
                            <Button 
                                color="success"
                                onClick={() => this.toogleCreateNewUser()}
                            >
                                Create new user
                            </Button>
                        </Col>
                    </Row>
                }
                <br />
                {isCreatingNewUser &&
                    <UserObject isCreatingNewUser user={newUser} />
                }
                <br />
                <Row>
                    {users.map(user =>
                        <Col xs={12}  className="user-item" key={user.id}>
                            <UserObject user={user} />
                        </Col>
                    )}
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/UserManagement/index.js